module.exports = __webpack_public_path__ + "static/img/img.c6ebf3d1.png";